import React from 'react'
import { SupportTeamLink } from './styled'

export const CONTACT_SUPPORT_TEAM = () => (
  <SupportTeamLink target="_blank" href="https://support.unroll.me/hc/en-us">
    Support Team
  </SupportTeamLink>
)
